module.exports = __webpack_public_path__ + "img/5.4f945199.png";